import { motion } from "framer-motion";
import { Asterisk } from "lucide-react";
import { Reveal, Overline, EASE } from "./motion";
import { useT } from "@/i18n/LangContext";

const STUDIO_IMG = "/images/studio.jpg";

export default function About() {
  const t = useT();

  return (
    <section id="studio" data-testid="studio-section" className="py-20 md:py-40">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-16 px-6 md:grid-cols-12 md:px-10">
        <motion.div
          initial={{ clipPath: "inset(0 100% 0 0)" }}
          whileInView={{ clipPath: "inset(0 0% 0 0)" }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease: EASE }}
          className="md:col-span-5"
          data-testid="studio-portrait-frame"
        >
          <div className="overflow-hidden rounded-b-[10rem] border border-lavline">
            <img
              src={STUDIO_IMG}
              alt={t.studio.imgAlt}
              className="aspect-[3/4] w-full object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>

        <div className="md:col-span-6 md:col-start-7">
          <Reveal>
            <Overline testId="studio-overline">{t.studio.overline}</Overline>
            <h2
              data-testid="studio-heading"
              className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-5xl"
            >
              {t.studio.headingA}
              <br />
              <em>{t.studio.headingEm}</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p
              data-testid="studio-body"
              className="mt-10 text-base font-light leading-relaxed text-ink/85 md:text-lg"
            >
              {t.studio.body1}
            </p>
            <p className="mt-6 text-base font-light leading-relaxed text-ink/85 md:text-lg">
              {t.studio.body2}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <ul
              className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2"
              data-testid="studio-proof-list"
            >
              {t.studio.proof.map((point) => (
                <li
                  key={point}
                  className="flex items-center gap-3 text-sm font-medium text-ink"
                >
                  <Asterisk className="h-4 w-4 shrink-0 text-bee" aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
